import { Button, Grid, Typography } from '@mui/material';
import { Form, Field } from 'formik';
import { TextField } from 'formik-mui';
import { Link, useLocation } from 'react-router-dom';

let CarrierForm = () => {
    let router = useLocation();

    let isNew = router.pathname.includes('/addnew');
    let title = isNew ? 'New carrier' : `Edit carrier`;

    return (
        <Form>
            <Grid container spacing={2}>
                <Grid item xs>
                    <Typography variant="h4">{title}</Typography>
                </Grid>
                <Grid item>
                    <Button
                        variant="outlined"
                        color="primary"
                        component={Link}
                        to={'/admin/carrier'}
                    >
                        Cancel
                    </Button>
                </Grid>
                <Grid item>
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                    >
                        Save
                    </Button>
                </Grid>
            </Grid>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Field
                        component={TextField}
                        name="carrierCode"
                        label="Carrier code"
                        disabled={isNew === false}
                        fullWidth
                        margin="dense"
                        size='small'
                    />
                </Grid>
                <Grid item xs={12}>
                    <Field
                        component={TextField}
                        name="trackingUrl"
                        label="Tracking url"
                        fullWidth
                        margin="dense"
                        size='small'
                    />
                </Grid>
            </Grid>
        </Form>
    );
}

export default CarrierForm;